import React from 'react';
import { createIcon } from '@chakra-ui/react';

const CallIcon = createIcon({
  displayName: 'CallIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d='M4.80634 5.86415L5.50875 5.16174C5.65745 5.01137 5.75993 4.82151 5.80404 4.61468C5.84815 4.40785 5.83205 4.19271 5.75764 3.99475C5.57039 3.49296 5.44051 2.97159 5.37048 2.4406C5.33292 2.17482 5.19999 1.93177 4.99647 1.75674C4.79295 1.58172 4.53274 1.48667 4.26433 1.48931H2.6051C2.45153 1.48946 2.29968 1.52157 2.1592 1.58362C2.01873 1.64567 1.89271 1.73629 1.78918 1.84971C1.68565 1.96313 1.60686 2.09686 1.55785 2.24239C1.50883 2.38793 1.49065 2.54208 1.50447 2.69502C1.68602 4.40458 2.26771 6.04733 3.20242 7.4902C4.05158 8.82653 5.18455 9.9595 6.52088 10.8087C7.95722 11.7401 9.59203 12.3217 11.2939 12.5066C11.4473 12.5205 11.602 12.5021 11.7479 12.4528C11.8938 12.4034 12.0278 12.3242 12.1413 12.22C12.2548 12.1159 12.3453 11.9892 12.407 11.8481C12.4687 11.7069 12.5003 11.5545 12.4996 11.4005V9.74122C12.5064 9.46998 12.4132 9.20572 12.2378 8.99871C12.0624 8.7917 11.817 8.65638 11.5484 8.61847C11.0174 8.54844 10.496 8.41856 9.99421 8.23132C9.79625 8.15691 9.5811 8.1408 9.37427 8.18491C9.16744 8.22902 8.97759 8.3315 8.82721 8.4802L8.12481 9.18261'
      stroke='currentColor'
      fill='transparent'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  ),
});

export default CallIcon;
